import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || '';

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const tenantId = localStorage.getItem('x_tenant_id');
  if (tenantId) {
    config.headers['X-Tenant-Id'] = tenantId;
  }
  const companyId = localStorage.getItem('x_company_id');
  if (companyId) {
    config.headers['X-Company-Id'] = companyId;
  }
  return config;
});

export default api;